
$(document).ready(function() {
    let proContainer = $('[data-custom-selector="44mojo_prd"]');

    // proContainer.find('[data-qty-2-bags="2qtybags"]').addClass("active_selected");
    proContainer.find('[data-save-10="10save_crd"]').addClass("active_selected");
    proContainer.find('[data-save-10="10save_crd"]').click();
    proContainer.find('[data-qty-2-bags="2qtybags"]').click();

    let oneTimeCard = $('.data_onetime_card');
    oneTimeCard.click(function() {
        if ($('[data-qty-2-bags="2qtybags"]').hasClass("active_selected")) {
            // $('[data-qty-2-bags="2qtybags"]').click();
        }
        if ($('[data-save-10="10save_crd"]').hasClass("active_selected")) {
            $('[data-save-10="10save_crd"]').click();
        }
    });

});


$(document).on('click', '.redirect_abv', function (e) {
  e.preventDefault();
  
  var targetId = $(this).attr('href'); 
  var target = $(targetId);

  if (target.length) {
    $('html, body').animate({
      scrollTop: target.offset().top
    }, 800);  
  } else {
   
  }
});
